import AudiencePage from "./pages/AudiencePage";

export default [
  { path: "/audience", element: <AudiencePage /> }
];
